// extracted by mini-css-extract-plugin
export default {"maskPopover":"PurchasePricePopover_maskPopover__6IJLW","divider":"PurchasePricePopover_divider__7AjW3"};